import { render } from "./ShowModalPSites.vue?vue&type=template&id=5b9bb55d&scoped=true"
import script from "./ShowModalPSites.vue?vue&type=script&lang=js"
export * from "./ShowModalPSites.vue?vue&type=script&lang=js"

import "./ShowModalPSites.vue?vue&type=style&index=0&id=5b9bb55d&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9bb55d"]])

export default __exports__